import React, { useState } from "react";
import logo from "../../assets/images/hamburger.png";
import axios from "axios";
import toast from "react-hot-toast";
import { liveUrl } from "../../utils/Constant";

function Header({ onToggleSidebar }) {
  const [showModal, setShowModal] = useState(false);

  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const handleSubmit = async () => {
    if (!oldPassword || !newPassword || !confirmPassword) {
      return toast.error("All fields are required");
    }

    if (newPassword !== confirmPassword) {
      return toast.error("New password & confirm password must be same");
    }

    try {
      const token = localStorage.getItem("token");

      const res = await axios.put(
        `${liveUrl}/auth/change-password`,
        { oldPassword, newPassword },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      toast.success("Password updated successfully");
      localStorage.removeItem("token");
      window.location.href = "/login";
      setShowModal(false);
    } catch (error) {
      toast.error(error.response?.data?.message || "Something went wrong");
    }
  };

  return (
    <>
      <header className="header">
        <img
          src={logo}
          alt="Logo"
          style={{ height: "20px" }}
          onClick={onToggleSidebar}
        />

        <div className="profile">
          <div style={{display:'flex', alignItems:'center', justifyContent:'center', gap:'10px'}}>
            <button className="changepass" onClick={() => setShowModal(true)}>
              Change Password
            </button>
            <div className="role">Admin</div>
          </div>
        </div>
      </header>

      {showModal && (
        <div className="modalBackground">
          <div className="modalContainer">

            <h2>Change Password</h2>

            <input
              type="password"
              placeholder="Old Password"
              value={oldPassword}
              onChange={(e) => setOldPassword(e.target.value)}
              className="modalInput"
            />

            <input
              type="password"
              placeholder="New Password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              className="modalInput"
            />

            <input
              type="password"
              placeholder="Confirm New Password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              className="modalInput"
            />

            <div className="modalActions">
              <button className="saveBtn" onClick={handleSubmit}>
                Update Password
              </button>
              <button className="cancelBtn" onClick={() => setShowModal(false)}>
                Cancel
              </button>
            </div>

          </div>
        </div>
      )}
    </>
  );
}

export default Header;
